import { ConfigState } from "../../models/ConfigState";

const getVendorConfigFetch = (state: ConfigState) => {
    state.isLoading = true;
}

export default getVendorConfigFetch;